import { NgModule, Injector } from '@angular/core';
import { CommonModule } from '@angular/common';

// components
import { FaqComponent } from './faq.component';

// services
import { AmorphicService } from '../../../../../coverpath-common/angular/services/amorphic/amorphic.service';
import { QuoteService } from '../../../../../coverpath-common/angular/services/quote/quote.service';
import { SharedModule } from '../../../../../coverpath-common/angular/components/shared/shared.module';

@NgModule({
  declarations: [FaqComponent],
  exports: [FaqComponent],
  imports: [CommonModule, SharedModule],
  providers: [AmorphicService, QuoteService],
  bootstrap: [FaqComponent],
})
export class FaqModule {
  /**
   * Allows for retrieving singletons using `AppModule.injector.get(MyService)`
   * (whereas `ReflectiveInjector.resolveAndCreate(MyService)` would create a
   * new instance of the service).
   */
  static injector: Injector;
  constructor(injector: Injector) {
    FaqModule.injector = injector;
  }
}
